import { useEffect, useRef } from "react";
import { cigs } from "../cigs";

export default function Cigs() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const cleanup = cigs(canvas);

    return () => {
      if (cleanup) cleanup();
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 420,
        background: "transparent"
      }}
    />
  );
}
